import CONSTANTS from '@/constants';
// Feltételezzük, hogy a bugsnag be van kötve máshol, vagy ide is importálható
// import Bugsnag from "@bugsnag/js";

const state = {
    status: 'error', // 'ok', 'error', 'sync'
    wasConnectedOnce: false,

    // UI vezérlők a kapcsolathoz kötve
    showRestoreDialog: false, // syncDialog az App.vue-ban
    isSyncing: false,         // GameSyncDialog az App.vue-ban
    currentConnectionStatus: 'ok',
    possibleConnectionStatuses: [
        'error',
        'ok',
        'sync',
    ],
    user: {},
    roomsize: null,
    dbname: null
};

const getters = {
    isConnected: state => state.status === 'ok',
    isOffline: state => state.status === 'error',
    // Segít eldönteni, hogy mutassuk-e a DC/RC gombokat (fejlesztői környezet)
    showDevTools: () => {
        const host = window.location.hostname.toLowerCase();
        return host.startsWith("localhost") || host.startsWith("dev") || host.startsWith("teszt");
    },
    getUser: state => state.user,
    getRoomSize: state => state.roomsize,
    getDbName: state => state.dbname
};

const mutations = {
    SET_ROOMSIZE(state, roomsize) {
        state.roomsize = roomsize;
    },
    SET_DBNAME(state, dbname) {
        state.dbname = dbname;
    },
    SET_USER(state, user) {
        state.user = user;
    },
    SET_STATUS(state, status) {
        state.status = status;
    },
    SET_CONNECTED_ONCE(state, value) {
        state.wasConnectedOnce = value;
    },
    SET_CONNECTION_STATUS(state, value) {
        state.currentConnectionStatus = value;
    },
    SET_RESTORE_DIALOG(state, value) {
        state.showRestoreDialog = value;
    },
    SET_SYNCING(state, value) {
        state.isSyncing = value;
    }
};

const actions = {
    /**
     * Ezt az action-t az App.vue created() vagy mounted() hookjában kell meghívni egyszer.
     * Feliratkozik a globális socket eseményekre.
     */
    // src/store/modules/connection.js

    initConnectionListeners({ commit, dispatch, state }) {
        if (!window.vueio) {
            console.error("Socket (window.vueio) nem található!");
            return;
        }

        // Segédfüggvény a csatlakozási logika kezelésére (hogy ne duplikáljuk a kódot)
        const onConnect = () => {
            console.log('Vuex: Socket connected / handled');
            commit('SET_STATUS', 'ok');

            if (state.wasConnectedOnce) {
                console.log("Vuex: Socket reconnected");
                window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.MATCHDATA);
            }

            commit('SET_CONNECTED_ONCE', true);
            dispatch('checkSyncStatus');
        };

        // 1. Feliratkozás az eseményekre (a jövőbeli változásokhoz)
        window.vueio.on('connect', onConnect);

        window.vueio.on('disconnect', () => {
            console.log('Vuex: Socket disconnected');
            commit('SET_STATUS', 'error');
        });

        window.vueio.on('reconnect', () => {
            dispatch('checkSyncStatus');
        });

        // 2. JAVÍTÁS: Ha MÁR csatlakozva vagyunk, akkor azonnal futtassuk le a logikát!
        // Mivel az App.vue-ban most már várunk a DB-re, valószínűleg lekéssük a 'connect' eseményt.
        if (window.vueio.connected) {
            onConnect();
        }
    },

    /**
     * Ellenőrzi, hogy van-e felszinkronizálandó adat
     * (Az eredeti App.vue logika alapján)
     */
    /**
     * Ellenőrzi, hogy van-e felszinkronizálandó adat
     */
    /**
     * Ellenőrzi, hogy van-e felszinkronizálandó adat
     */
    // JAVÍTÁS: Hozzáadtuk a 'rootState'-et a paraméterekhez, hogy ellenőrizhessük a belépést
    async checkSyncStatus({ commit, state, dispatch, rootState }) {
        try {
            // --- JAVÍTÁS: ADATBÁZIS NÉV ELLENŐRZÉSE ---
            // Nem elég azt nézni, hogy be vagyunk-e lépve.
            // Azt is nézni kell, hogy NEM az 'mksz' rendszer-adatbázist használjuk-e éppen.
            const currentDB = window.dbmanager.dbname;
            const isMatchDB = currentDB && currentDB !== 'mksz';

            if (rootState.ui.isLoggedin && isMatchDB) {
                await dispatch('game/syncOfflineData', null, { root: true });
            }
            // ------------------------------------------

            await window.dbmanager.sync();

            if (window.roomsize > 0) {
                const count = await window.dbmanager.getSyncableCount();
                commit('game/SET_SYNCABLE_COUNT', count, { root: true });

                if (count < 2) {
                    window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.MATCHDATA);
                } else {
                    commit('SET_RESTORE_DIALOG', true);
                }
            }
        } catch (error) {
            console.error("Sync check error:", error);
        }
    },

    /**
     * Manuális kapcsolatbontás (pl. Dev gomb)
     */
    disconnect() {
        window.vueio.disconnect();
    },

    /**
     * Manuális újracsatlakozás (pl. Dev gomb)
     */
    reconnect({ dispatch, rootState }) {
        window.vueio.connect();
    },

    /**
     * Dialog bezárása
     */
    closeRestoreDialog({ commit }) {
        commit('SET_RESTORE_DIALOG', false);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
